function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M207.8 400c0 27 21.6 48 48.1 48s48.1-21 48.1-48h-96.2zM133.8 32L120 40.1 378.2 480l13.8-8.1zM373.9 229c0-99.1-49-132.9-94.9-140.6 0-.6.1-1.1.1-1.7 0-12.7-10.3-23-23-23s-23 10.3-23 23c0 .6 0 1.2.1 1.8-13.1 2.2-26.5 6.6-38.9 14L359 383.9h73c-35.4-32-58.1-39-58.1-154.9zM138.1 229.2C138.1 345.1 115.6 352 80 384h222.9L159 138c-12.8 21.4-20.9 50.9-20.9 91.2z"
});

function SvgIosNotificationsOff({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIosNotificationsOff);
export default __webpack_public_path__ + "static/media/ios-notifications-off.9579f942.svg";
export { ForwardRef as ReactComponent };